/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Single-stranded DNA counts one strand; double-stranded DNA adds the complementary strand, so its molecular weight is roughly twice that of the single strand.`)
};

const es_dnamw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El ADN monocatenario cuenta una hebra; el ADN bicatenario suma la hebra complementaria, así que su peso molecular es aproximadamente el doble del de la hebra simple.`)
};

const de_dnamw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzelsträngige DNA zählt einen Strang; doppelsträngige DNA addiert den komplementären Strang, sodass ihr Molekulargewicht etwa doppelt so hoch ist wie das des Einzelstrangs.`)
};

const nl_dnamw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enkelstrengs DNA telt één streng; dubbelstrengs DNA voegt de complementaire streng toe, dus het molecuulgewicht is ongeveer twee keer dat van de enkele streng.`)
};

const fr_dnamw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'ADN simple brin compte un seul brin ; l'ADN double brin ajoute le brin complémentaire, donc sa masse moléculaire est environ le double de celle du brin simple.`)
};

const it_dnamw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il DNA a singolo filamento conta un solo filamento; il DNA a doppio filamento aggiunge il filamento complementare, quindi il suo peso molecolare è circa il doppio di quello del singolo filamento.`)
};

const pt_br2_dnamw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA de fita simples conta uma fita; DNA de fita dupla soma a fita complementar, então seu peso molecular é aproximadamente o dobro da fita simples.`)
};

const pt_dnamw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O ADN de cadeia simples conta uma cadeia; o ADN de cadeia dupla adiciona a cadeia complementar, pelo que a sua massa molecular é aproximadamente o dobro da da cadeia simples.`)
};

const ja_dnamw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一本鎖DNAは1本の鎖をカウントします。二本鎖DNAは相補鎖を加えるため、その分子量は一本鎖のおよそ2倍になります。`)
};

const zh_dnamw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单链 DNA 只计算一条链；双链 DNA 还要加上互补链，因此其分子量大约是单链的两倍。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_faq_a2", locale)
	if (locale === "en") return en_dnamw_faq_a2(inputs)
	if (locale === "es") return es_dnamw_faq_a2(inputs)
	if (locale === "de") return de_dnamw_faq_a2(inputs)
	if (locale === "nl") return nl_dnamw_faq_a2(inputs)
	if (locale === "fr") return fr_dnamw_faq_a2(inputs)
	if (locale === "it") return it_dnamw_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_faq_a2(inputs)
	if (locale === "pt") return pt_dnamw_faq_a2(inputs)
	if (locale === "ja") return ja_dnamw_faq_a2(inputs)
	return zh_dnamw_faq_a2(inputs)
};